import { z } from "zod";

export const requestReturnSchema = z.object({
  orderItemId: z.string().min(1),
  reason: z.string().trim().min(3).max(500)
});
export type RequestReturnInput = z.infer<typeof requestReturnSchema>;

export const updateReturnStatusSchema = z.object({
  status: z.enum(["APPROVED", "REJECTED", "COMPLETED"]),
  adminNote: z.string().trim().max(500).optional()
});
export type UpdateReturnStatusInput = z.infer<typeof updateReturnStatusSchema>;
